import '@vscode/codicons/dist/codicon.css';

import type { ComponentPropsWithoutRef } from 'react';

type CodiconProps = ComponentPropsWithoutRef<'span'>;

const createCodicon = (codiconName: string) => {
  const Codicon = ({ className, ...props }: CodiconProps) => {
    const combinedClassName = className
      ? `codicon codicon-${codiconName} ${className}`
      : `codicon codicon-${codiconName}`;

    return (
      <span aria-hidden={props['aria-label'] == null ? true : undefined} className={combinedClassName} {...props} />
    );
  };

  Codicon.displayName = `Codicon${codiconName}`;

  return Codicon;
};

export const Layout = createCodicon('layout');
export const LayoutStatusbar = createCodicon('layout-statusbar');
export const LayoutSidebarRight = createCodicon('layout-sidebar-right');
export const LayoutSidebarRightOff = createCodicon('layout-sidebar-right-off');
export const LayoutSidebarRightDock = createCodicon('layout-sidebar-right-dock');
export const LayoutSidebarLeft = createCodicon('layout-sidebar-left');
export const LayoutSidebarLeftOff = createCodicon('layout-sidebar-left-off');
export const LayoutSidebarLeftDock = createCodicon('layout-sidebar-left-dock');
export const LayoutPanel = createCodicon('layout-panel');
export const LayoutPanelRight = createCodicon('layout-panel-right');
export const LayoutPanelOff = createCodicon('layout-panel-off');
export const LayoutPanelLeft = createCodicon('layout-panel-left');
export const LayoutPanelJustify = createCodicon('layout-panel-justify');
export const LayoutPanelDock = createCodicon('layout-panel-dock');
export const LayoutPanelCenter = createCodicon('layout-panel-center');
export const LayoutMenubar = createCodicon('layout-menubar');
export const LayoutCentered = createCodicon('layout-centered');
export const LayoutActivitybarRight = createCodicon('layout-activitybar-right');
export const LayoutActivitybar = createCodicon('layout-activitybar-left');

export const LayoutCodicons = {
  layout: Layout,
  'layout-statusbar': LayoutStatusbar,
  'layout-sidebar-right': LayoutSidebarRight,
  'layout-sidebar-right-off': LayoutSidebarRightOff,
  'layout-sidebar-right-dock': LayoutSidebarRightDock,
  'layout-sidebar-left': LayoutSidebarLeft,
  'layout-sidebar-left-off': LayoutSidebarLeftOff,
  'layout-sidebar-left-dock': LayoutSidebarLeftDock,
  'layout-panel': LayoutPanel,
  'layout-panel-right': LayoutPanelRight,
  'layout-panel-off': LayoutPanelOff,
  'layout-panel-left': LayoutPanelLeft,
  'layout-panel-justify': LayoutPanelJustify,
  'layout-panel-dock': LayoutPanelDock,
  'layout-panel-center': LayoutPanelCenter,
  'layout-menubar': LayoutMenubar,
  'layout-centered': LayoutCentered,
  'layout-activitybar-right': LayoutActivitybarRight,
  'layout-activitybar': LayoutActivitybar,
} as const;
